<template>
<div class="header">

    <div class="wrap">

        <div class="logo">
            <img class="zoom-img" src="/static/images/logo.png" alt="">
        </div>
                <div class="logo2">
            <img class="zoom-img" src="/static/images/zitilogo2.png" alt="">
        </div>
        <div class="bar_list">
            <ul>
                <li><a class="active" href="/">首页</a></li>
                <li class=" bar"><a href="/logo/creatlogo.html">logo生成</a>

                </li>


            </ul>
        </div>

    </div>

</div>
</template>

<script>
export default {
name: "headers"
}
</script>

<style>
.header{
    animation: paddingChangeMobile .5s;
    background-color: #fff;

    padding: 15px 0 10px;
    height: 35px;
    position: sticky;
    width: 100%;
    top: 0;
    z-index: 1;
    margin-bottom: 20px;
}
.header .user-head {
    display: flex;
    align-items: center;
    position: relative;
    float: right;
}
.header .user-head .head-img {
    position: relative;
    margin-right: 10px;
    width: 35px;
}
.header .user-name{
    font-size: 12px;
    text-align: left;

}
.header .user-name span:nth-of-type(1){
    font-weight: 700;
    
}
.header .user-name span:nth-of-type(2){
    color: #3c7ee5;
    
}
.shadow{
text-align: -webkit-auto !important;
}

 shadow::before {
    content: '';
    box-shadow: 0 0 10px 1px #333;
    position: fixed;
    width: 100%;
  }
   
shadow::after {
    content: '';
    width: 100%;
    height: 15px;
    background: linear-gradient(to bottom, #fff 50% , transparent);
    position: absolute;
  }

.header .logo{
    float: left;
    width: 40px;
}
.header .logo2{
    float: left;
    width: 80px;
}
.header.logo img{
    vertical-align:middle;
}
.header .bar_list{
    float: left;
}
.bar_list>ul>li{
    float: left;
    padding: 0 30px;
    font-size: 14px;
    line-height: 30px;
}
.bar_list>ul>li>a{
    position: relative;
    line-height: 40px;

}

.bar_list>ul>li>a:hover:after{
    position: absolute;
    left: 0;
    right: 0;
    height: 4px;
    background-color: #53b1be;
    border-radius: 2px;
    content: '';
    top: 140%;
}
.header .active::before{
    position: absolute;
    left: 0;
    right: 0;
    height: 4px;
    background-color: #53b1be;
    border-radius: 2px;
    content: '';
    top: 140%;
}

.down>a:before{
    position: absolute;
    top: 50%;
    right: -16px;
    margin-top: -3px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent;
    border-top-color: #ccc;
    content: '';
}
.regbts{
    line-height: 35px;
    float: right;
}
.regbtn{

        cursor: pointer;
        color: #fff!important;
        background: #00b395;
        padding: 10px 20px;
        border-radius: 20px;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        margin-top: 32px;

    
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue